export default __webpack_public_path__ + "static/media/playstore.c6a68f1e.svg";